import {emptyForm, handleApiForm, handleValidationErrors} from "../../forms";
import {closeModal} from "../../utilities";
import * as $ from "jquery";
import {toastAlert} from "../../toastAlert";
import moment from "moment";
import {confirmModal} from "../../confirmModal";
import axios from "axios";
import Spinner from "../../spinner";
import {handleShpForm} from "../../shp";

export const forestAddressesPage = () => {
    const body = $('body');

    handleApiForm('#addSet', ({response, form}) => {
        closeModal('#addSetModal');

        let table = $('#setTable').DataTable();

        let set = response.data.set;
        let row = $(`
            <tr data-id="${set.id}">
                <td class="set__date">${moment(set.date).format('DD/MM/YYYY')}</td>
                <td>
                    <a class="btn btn-primary btn-sm" href="${window._EDIT_SET_URL.replace('REPLACE_ID', set.id)}">
                        Edytuj
                    </a>
                    <button data-id="${set.id}" type="button" class="btn btn-sm btn-danger btnDeleteSet">
                        Usuń
                    </button>
                </td>
            </tr>
        `)

        table.api().rows.add(row).draw(false);

        emptyForm(form);
        toastAlert('Pomyślnie dodano zestaw');
    })

    // Delete set
    body.on('click', '.btnDeleteSet', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć wybrany zestaw?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        const spinner = new Spinner();

        try {
            const response = await axios.post(
                window._DELETE_SET_URL.replace('REPLACE_ID', id)
            );

            if (response.data.code === 400) {
                toastAlert(response.data.message, {type: 'danger'})
                spinner.destroy();
                return;
            }

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#setTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto zestaw');
            spinner.destroy();
        } catch (err) {
            spinner.destroy();
            toastAlert('Wystąpił błąd podczas próby usunięcia zestawu', {type: 'danger'})
        }
    })

    /// commons
    $('#commonTable').DataTable({
        order: [1, 'asc'],
        'columnDefs': [
            {
                'targets': 1,
                'type': 'natural'
            },
            {
                'targets': 2,
                'type': 'natural'
            },
        ]
    })

    handleApiForm('#addCommon', ({response, form}) => {
        closeModal('#addCommonModal');

        let table = $('#commonTable').DataTable();

        let common = response.data.common;
        let row = $(`
            <tr data-id="${common.id}">
                <td>${common.name}</td>
                <td>${common.code}</td>
                <td>${common.full_code}</td>
                <td>
                    <a class="btn btn-primary btn-sm" href="${window._EDIT_COMMON_URL.replace('REPLACE_ID', common.id)}">
                        Edytuj
                    </a>
                    <button data-id="${common.id}" type="button" class="btn btn-sm btn-danger btnDeleteCommon">
                        Usuń
                    </button>
                </td>
            </tr>
        `)

        table.api().rows.add(row).draw(false);

        emptyForm(form);
        toastAlert('Pomyślnie dodano adres leśny');
    })

    body.on('click', '.btnDeleteCommon', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć wybrany adres?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        const spinner = new Spinner();

        try {
            const response = await axios.post(
                window._DELETE_COMMON_URL.replace('REPLACE_ID', id),
                {
                    class: window._COMMON_CLASS,
                    set_id: window._SET_ID
                }
            );

            if (response.data.code === 400) {
                toastAlert(response.data.message, {type: 'danger'})
                spinner.destroy();
                return;
            }

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#commonTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto adres');
            spinner.destroy();
        } catch (err) {
            spinner.destroy();
            toastAlert('Wystąpił błąd podczas próby usunięcia adresu', {type: 'danger'})
        }
    })

    /// import from shp
    const importSetModal = $('#importSetModal');
    const form = importSetModal.find('form')
    const fieldsContainer = importSetModal.find('[data-app-fields_container]');
    let importFeatures = [];
    let valid = [];

    $('#btnImportShpSubmit').click(async function () {
        // if has any, then it means that its second click
        if (importFeatures.length) {
            const spinner = new Spinner();
            try {
                const data = {
                    date: form.find('[name="date"]').val(),
                    addresses: valid
                }

                const response = await axios.post(window._BULK_SYNC_SET_URL, data);
                if (parseInt(response.data.code) !== 200) {
                    toastAlert('Wystąpił błąd podczas próby zapisu adresów: '.response.data.message, {type: 'danger'});
                    handleValidationErrors(response.data.errors);

                    spinner.destroy();
                    return;
                }

                spinner.destroy();
                await confirmModal(`
                    - Nowe nadleśnictwa: ${response.data.newData.supervisions}<br/>
                    - Nowe obręby: ${response.data.newData.regions}<br/>
                    - Nowe leśnictwa: ${response.data.newData.forestries}<br/>
                    - Nowe wydzielenia: ${response.data.newData.subareas}<br/>
                `, {
                    title: 'Pomyślnie zsynchronizowano dane', color: 'success', buttons: [{
                        text: 'Ok',
                        color: 'success',
                        type: 'resolve'
                    }]
                });
                window.location.reload();
            } catch (err) {
                spinner.destroy();
                toastAlert('Wystąpił błąd podczas próby zapisu adresów', {type: 'danger'});
            }

            return;
        }

        importFeatures = await handleShpForm(form)

        if (importFeatures.length) {
            const notValid = [];

            for (const feature of importFeatures) {
                try {
                    const addr = feature.get('ADR_FOR');
                    if (addr.length) {
                        valid.push(addr);
                    }
                } catch (err) {
                    notValid.push()
                }
            }

            $(this).text('Zapisz');
            fieldsContainer.find('.row').append(`<div class="col-12">Z pliku udało się załadować <strong>${valid.length}</strong> adresów leśnych. Kliknij przycisk "Zapisz", aby zapisać zestaw danych.</div>`);

            if (notValid.length) {
                fieldsContainer.find('.row').append(`<div class="col-12"><span class="text-danger">Nie udało się załadować ${notValid.length} adresów.</span></div>`)
            }

            fieldsContainer.show();
            importSetModal.find('[data-app-file_container]').hide();
        } else {
            confirmModal('W podanym pliku nie znaleziono geometrii lub geometria jest zepsuta')
        }
    })
}